<template>
  <div>
    <QueryFrame
      @addNew="addNew"
      :add-text="handlePermission('warehouseAdd')?'新建仓库':''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>仓库名称:</label>
          <lk-input class="item" clearable v-model.trim="query.warehouseName" :maxlength="100"></lk-input>
        </div>
        <div class="queryItem">
          <label>仓库属性:</label>
          <lk-cascader class="item" :data="warehouseAttributeList" v-model="query.warehouseAttributeSelect"></lk-cascader>
        </div>
        <div class="queryItem">
          <label>库管员:</label>
          <lk-select class="item" clearable v-model="query.warehouseManagerId">
            <lk-option v-for="item in warehouseManagerList" :value="item.value" :key="item.value">{{ item.label }}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import system from '../../services/system';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'warehouse',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    hasWarehouseEdit() {
      return this.handlePermission('warehouseEdit');
    },
  },
  data() {
    return {
      warehouseAttributeList: [], // 仓库属性列表
      warehouseManagerList: [], // 库管员列表
      query: {
        storeIdList: [], // 门店名称
        warehouseName: null, // 仓库名称
        warehouseAttributeSelect: [], // 仓库[类型, 属性]
        warehouseType: null, // 仓库类型
        warehouseAttributeSign: null, // 仓库属性
        warehouseManagerId: null,
      },
      columns: [
        {
          title: '仓库编码',
          key: 'warehouseCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '仓库名称',
          key: 'warehouseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '仓库类型',
          key: 'warehouseType',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.warehouseAttributeMap.get(row.warehouseType).get('label')),
        },
        {
          title: '仓库属性',
          key: 'warehouseAttributeSignStr',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.warehouseAttributeMap.get(row.warehouseType).get(row.warehouseAttributeSign)),
        },
        {
          title: '库管员',
          key: 'managerName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '位置说明',
          key: 'warehouseAddress',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '特殊说明',
          key: 'warehouseRemark',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', utils.exchangeTime(row.createTime)),
        },
        {
          title: '状态',
          key: 'isUsing',
          minWidth: 116,
          render: (h, { row }) => (this.hasWarehouseEdit ? h('lk-switch', {
            props: {
              size: 'large',
              value: row.isUsing === 1,
              loading: row.loading,
            },
            on: {
              'on-change': (value) => {
                row.loading = true;
                inventory.warehouseHandleStatus({
                  id: row.id,
                  status: value ? 1 : 2,
                })
                  .then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(value ? '该仓库已启用' : '该仓库已禁用');
                      row.isUsing = value ? 1 : 2;
                    } else {
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                    row.loading = false;
                  })
                  .catch((err) => {
                    this.getData();
                    utils.handleError(err);
                  });
              },
            },
          }, [
            h('span', {
              slot: 'open',
            }, '启用'),
            h('span', {
              slot: 'close',
            }, '禁用'),
          ]) : h('span', row.isUsing === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 80,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.hasWarehouseEdit ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.isUsing !== 1,
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'warehouseEdit',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
      warehouseAttributeMap: [],
    };
  },
  methods: {
    getWarehouseAttributeList() {
      return new Promise((resolve) => {
        inventory.warehouseAttributeList()
          .then((res) => {
            if (res.status === 200 && res.data.status === 200) {
              const data = res.data.data;
              this.warehouseAttributeList = data;
              this.warehouseAttributeMap = this.getWarehouseAttributeMap(data);
              resolve();
            } else {
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            utils.handleError(err);
          });
      });
    },
    // 构建仓库类型和属性映射表
    getWarehouseAttributeMap(data) {
      if (!data) {
        return;
      }
      const warehouseAttributeMap = new Map();
      data.forEach((item) => {
        const childMap = new Map();
        item.children.forEach((child) => {
          childMap.set(child.value, child.label);
        });
        childMap.set('label', item.label); // 父级属性的名称
        warehouseAttributeMap.set(item.value, childMap);
      });
      return warehouseAttributeMap;
    },
    getData() {
      if (this.params.warehouseAttributeSelect.length >= 1) {
        const [type, ...attributies] = this.params.warehouseAttributeSelect;
        this.params.warehouseType = type; // 仓库类型
        this.params.warehouseAttributeSign = attributies.pop(); // 仓库属性
      }
      this.params.page = this.page;
      this.params.size = this.size;
      inventory.warehouseList(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = res.data.data.list;
            this.count = res.data.data.count;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    addNew() {
      this.$router.push({ name: 'warehouseAdd' });
    },
    handleReset() {
      this.query = {};
    },
    getWarehouseManagerList() {
      const params = {
        page: 1,
        size: 100,
        statusCodeList: [1], // 1启用 2禁用
      };
      system.storeUserList(params)
        .then((res) => {
          if (res.data.status === 200) {
            res.data.data.list.forEach((item) => {
              const { id: value, name: label } = item.sysUser;
              this.warehouseManagerList.push({ value, label });
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
    // 没有编辑权限，移除操作列
    if (!this.hasWarehouseEdit) {
      this.columns.pop();
    }
    this.getWarehouseAttributeList()
      .then(() => {
        this.getWarehouseManagerList();
        this.handleSearch(true);
      });

    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>

<style lang="less" scoped>
</style>
